import { Icon } from "@iconify/react/dist/iconify.js";
import { Box, ButtonBase, FormHelperText, Grid, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import TableStyle2 from "../../../components/Common/TableStyle2";
import CustomButton from "../../../components/Form/CustomButton";
import CustomSelect from "../../../components/Form/CustomSelect";
import AddSalesman from "../modal/AddSalesman";

const AssignSalesman = ({ formObj, handleFormChange, vehicle, bodyList, windowWidth, error, branchList,
    salesmanList, isDirectSeller, setVehicleDetailsOpen }) => {

    const [newSalesman, setNewSalesman] = React.useState([]);
    const [selectedRow, setSelectedRow] = React.useState();
    const [openAddSalesManModal, setOpenAddSalesManModal] = React.useState();
    const [editIdx, setEditIdx] = React.useState(null);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const header = [
        {
            title: 'Name',
            accessor: (item, idx) => {
                const salesmanName = salesmanList?.find((salesman) => salesman.id === item?.salesman_id)?.name || '-';
                return (
                    <>
                        {
                            selectedRow?.temp_id === idx ?
                                <CustomSelect
                                    values={selectedRow?.salesman_id || '-1'}
                                    onChange={(e) => {
                                        const selectedOption = salesmanList?.find((salesman) => salesman.id === e);
                                        setSelectedRow({ ...selectedRow, salesman_id: e, contact: selectedOption?.phone || '', location_id: selectedOption?.branch_id || '', location_name: selectedOption?.branch_name || '' });
                                    }}
                                    data={(salesmanList || []).filter(salesman =>
                                        selectedRow?.salesman_id === salesman.id || // Include the currently selected salesman
                                        (!newSalesman.some(newSm => newSm.salesman_id === salesman.id) &&
                                            !formObj?.salesman?.some(existingSm => existingSm.salesman_id === salesman.id))
                                    ) || []}
                                    labelName={'name'}
                                    valueName={'id'}
                                    placeholder={'Salesman'}
                                    height={30}
                                    marginTop="7px"
                                    padding={"0px"}
                                />
                                : salesmanName
                        }
                    </>
                )
            }
        },
        {
            title: 'Branch',
            accessor: (item, idx) => {
                return (
                    <>
                        {
                            selectedRow?.temp_id === idx ?
                                <CustomSelect
                                    values={selectedRow?.location_id || '-1'}
                                    onChange={(e) => { setSelectedRow({ ...selectedRow, location_id: e, location_name: branchList.find((location) => location.id === e)?.branch_name || '' }); }}
                                    data={branchList || []}
                                    labelName={'branch_name'}
                                    valueName={'id'}
                                    placeholder={'Branch'}
                                    height={30}
                                    marginTop="7px"
                                    padding={"0px"}
                                />
                                : branchList?.find((loc) => loc.id === item?.location_id)?.branch_name || '-'
                        }
                    </>
                )
            }
        },
        {
            title: 'Contact',
            accessor: (item, idx) => {
                return (selectedRow?.temp_id === idx ? selectedRow?.contact || '-' : item?.contact || '-')
            }
        },
        {
            title: 'Action',
            accessor: (item, idx) => {
                return (
                    <div className="d-flex align-items-center">
                        <div
                            style={{ color: selectedRow?.temp_id === idx ? '#B48A3C' : '#1D1B1B', cursor: 'pointer', textDecoration: selectedRow?.temp_id === idx ? 'underline' : 'none' }}
                            onClick={() => selectedRow?.temp_id === idx ? handleEditSalesman(item, idx) : setSelectedRow({ ...item, temp_id: idx })}
                        >
                            {selectedRow?.temp_id === idx ? 'Save' : 'Edit'}
                        </div>
                        {
                            selectedRow?.temp_id === idx &&
                            <div className="mx-3 clickable" onClick={() => handleRemoveSalesman(idx)} style={{ color: '#D13536' }}>Remove</div>
                        }
                    </div>

                )
            }
        },
    ];

    const inputListing = [
        {
            name: 'salesman_id',
            inputType: 'select',
            placeholder: 'Salesman',
            labelName: 'name',
            valueName: 'id',
            data: (salesmanList || []).filter(salesman =>
                // !newSalesman.some(newSm => newSm.salesman_id === salesman.id) &&
                !formObj?.salesman?.some(existingSm => existingSm.salesman_id === salesman.id)
            ),
        },
        {
            name: 'location_id',
            inputType: 'select',
            placeholder: 'Branch',
            labelName: 'branch_name',
            valueName: 'id',
            data: branchList || [],
        },
        {
            name: 'contact',
            view: true,
        },
        {
            name: 'action',
            actionName: 'Save',
            removeAction: true,
            actionOnClick: (e) => { handleSaveNewSalesman(e) }
        }
    ]

    const handleSaveNewSalesman = (salesman) => {
        let temp = Array.isArray(formObj?.salesman) ? [...formObj?.salesman] : [];
        temp.push({ ...salesman, temp_id: (formObj?.salesman?.length + 1) || 1 });
        handleFormChange('salesman', temp);
        //remove from newSalesman
        let updatedNewSalesman = [...newSalesman];
        updatedNewSalesman = updatedNewSalesman.filter((item) => item !== salesman);
        setNewSalesman(updatedNewSalesman);
    }

    const handleEditSalesman = (salesman, index) => {
        let temp = [...formObj?.salesman];
        temp[index] = { ...selectedRow };
        handleFormChange('salesman', temp);
        setSelectedRow(null);
    }

    const handleRemoveSalesman = (index) => {
        let temp = [...formObj?.salesman];
        temp.splice(index, 1);
        handleFormChange('salesman', temp);
        setSelectedRow(null);
    }

    return (
        <React.Fragment>
            <Box className="vehicle-info-container">
                <div className="vehicle-selected-absolute">
                    Selected
                </div>
                <div className="text-semibold font-size-18 pt-2">{vehicle?.make || '-'} {vehicle?.model || ''} {vehicle?.manu_year ? (`(${vehicle?.manu_year})`) : ''}</div>
                <Box sx={{ display: { lg: 'flex', md: 'flex' }, justifyContent: { lg: 'space-between', md: 'space-between' } }}>
                    <Stack sx={{ flexDirection: { lg: 'row', md: 'row', sm: 'column', xs: 'column' }, gap: 2, mt: 2 }}>
                        <div className="d-flex align-items-center">
                            <div className="subheader-2">Reg. No:</div>
                            <div className="mx-1">{vehicle?.reg_no || '-'}</div>
                        </div>
                        <div className="d-flex align-items-center">
                            <div className="subheader-2">Stock ID:</div>
                            <div className="mx-1">{vehicle?.stock_id || '-'}</div>
                        </div>
                        <div className="d-flex align-items-center">
                            <div className="subheader-2">Body Type:</div>
                            <div className="mx-1">{Array.isArray(vehicle?.body_type) && vehicle?.body_type.length > 0 ? vehicle.body_type?.map((item, idx) => bodyList?.find((body) => body.id === item)?.name).join(', ') : vehicle?.body_type || '-'}</div>
                        </div>
                    </Stack>
                    <div className="d-flex align-items-end">
                        <ButtonBase onClick={() => setVehicleDetailsOpen(true)} style={{ borderRadius: 10, paddingInline: 5 }}>
                            <div className="d-flex align-items-center" style={{ color: '#B48A3C' }}>View details <Icon icon={'fluent:chevron-right-20-regular'} style={{ marginLeft: 5, height: 16 }} /></div>
                        </ButtonBase>
                    </div>
                </Box>
            </Box>
            <Box mt={4}>
                <Grid container spacing={1}>
                    <Grid item container sm={12} className="d-flex align-items-center mb-2">
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <div className="text-semibold">
                                Salesman
                                {error?.salesmans && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.salesmans || ""}</FormHelperText>}
                            </div>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                            <CustomButton
                                title={'Add Salesman'}
                                padding={22}
                                press={() => windowWidth <= 768 ? setOpenAddSalesManModal(true) : setNewSalesman([...newSalesman || [], { salesman_id: '', location_id: '', contact: '' }])}
                            />
                        </Grid>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <TableStyle2
                            header={header}
                            tableData={formObj?.salesman || []}
                            inputListing={inputListing}
                            width={windowWidth}
                            customResponsiveTable={
                                <Grid>
                                    {formObj?.salesman?.length > 0 ?
                                        formObj?.salesman?.map((x, idx) => (
                                            <Box
                                                key={idx}
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    p: 2,
                                                    border: "1px solid #E0E0E0",
                                                    borderRadius: 2,
                                                    mb: 1,
                                                }}
                                            >
                                                <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                    <span>
                                                        <b>{salesmanList?.find((salesman) => salesman.id === x?.salesman_id)?.name || "-"}</b>
                                                    </span>
                                                    <span className="text-muted">
                                                        {branchList?.find((loc) => loc.id === x?.location_id)?.branch_name || "-"}, {x?.contact}
                                                    </span>
                                                </Box>
                                                <div style={{ display: "flex", gap: 10 }}>
                                                    <Icon
                                                        icon="ri:pencil-line"
                                                        onClick={() => { setOpenAddSalesManModal(true); setSelectedRow({ ...x, temp_id: idx }); setEditIdx(idx); }}
                                                        style={{ cursor: "pointer", fontSize: 20 }}
                                                    />
                                                    <Icon
                                                        icon="ri-close-line"
                                                        onClick={() => handleRemoveSalesman(idx)}
                                                        style={{ cursor: "pointer", fontSize: 20 }}
                                                    />
                                                </div>

                                            </Box>
                                        ))
                                        : "No salesmen assigned yet."
                                    }
                                </Grid>
                            }
                            setInput={setNewSalesman}
                            inputArr={newSalesman}
                            inputActionButton={(e) => (
                                <div className="clickable text-underline" onClick={() => { handleSaveNewSalesman(e) }}>Save</div>
                            )}
                        />
                    </Grid>
                </Grid>
            </Box>
            <AddSalesman
                open={openAddSalesManModal}
                salesmanList={
                    editIdx === null
                        ? (salesmanList || []).filter(
                            salesman =>
                                !formObj?.salesman?.some(
                                    existingSm => existingSm.salesman_id === salesman.id
                                )
                        )
                        : (salesmanList || []).filter(
                            salesman =>
                                selectedRow?.salesman_id === salesman.id ||
                                (
                                    !newSalesman.some(
                                        newSm => newSm.salesman_id === salesman.id
                                    ) &&
                                    !formObj?.salesman?.some(
                                        existingSm => existingSm.salesman_id === salesman.id
                                    )
                                )
                        )
                }
                editIdx={editIdx}
                branchList={branchList}
                values={selectedRow}
                setFormValues={setSelectedRow}
                close={() => { setOpenAddSalesManModal(false); setSelectedRow(null); setEditIdx(null); }}
                handleAdd={(data) => { handleSaveNewSalesman(data); setOpenAddSalesManModal(false); setSelectedRow(null); setEditIdx(null); }}
                handleEdit={(data) => { handleEditSalesman(data, editIdx); setOpenAddSalesManModal(false); setSelectedRow(null); setEditIdx(null); }}
            />
        </React.Fragment >
    )
}

function mapStateToProps({ General, Layout, Login }) {
    const currentStateId = Login?.verifyAdmin?.user?.data?.profile?.state_id;
    // const filteredBranchList = General?.states?.find((state) => state.id === currentStateId)?.cities || [];
    return {
        windowWidth: Layout.currentWidth,
        bodyList: General.bike_types,
        salesmanList: General.dealer_salesmans,
        branchList: General?.dealer_branches || [],
    };
}


export default connect(mapStateToProps)(AssignSalesman);